angular.module('acme.common.service.featureToggle', [])
  .provider('FeatureToggleService', FeatureToggleServiceProvider);

function FeatureToggleService(endpoint, $q, $http, $timeout) {
  var features = [], // default all features are disabled
    isLoaded = false,
    deferredLoad = $q.defer(),
    activeTogglesEndpoint = '/active',
    tenantCart = 'TENANT_CART';

  return {
    has: has,
    load: load,
    reload: reload,
    loaded: loaded,
    fetch: fetch,
    check: check,
    reset: reset
  };

  /**
   * Attempt to load feature flags
   */
  function load() {
    // var url = endpoint + activeTogglesEndpoint;

    //leave this comment - it's for local development
    var url = "/assets/data/features.json";

    $http.get(url, {timeout: 6000})
    .then(function (response) {
      features = response.data;
      isLoaded = true;
      deferredLoad.resolve(features);
    })
    .catch(function () {
      deferredLoad.reject();
    });

    return deferredLoad.promise;
  }

  function reload() {

    // Reset
    deferredLoad = $q.defer();
    reset();

    load();
  }

  function reset() {
    features = [];
    isLoaded = false;
  }

  /**
   * Check if current has Feature
   *
   * By default this will return false if feature flags aren't loaded
   * @param {string} id - feature flag ID
   * @returns {boolean}
   */
  function has(id) {
    return tenantCart === id || features.indexOf(id) > -1;
  }

  /**
   * Check if current has any one of the provided list of features
   *
   * By default this will return false if feature flags aren't loaded
   * @param {Array} features - list of feature flag ids
   * @returns {boolean}
   */
  function check (features) {
    var _isUserAllowed = true,
        self = this;

    if (features) {
      _isUserAllowed = [].concat(features)
        .filter(function (feat) {
          return self.has(feat);
        }).length > 0;
    }

    return _isUserAllowed;
  }

  function loaded() {
    return deferredLoad.promise;
  }

  function fetch() {
    return features;
  }
}

function FeatureToggleServiceProvider() { }

FeatureToggleServiceProvider.prototype.setEndpoint = function (endpoint) {
  this.endpoint = endpoint;
};

FeatureToggleServiceProvider.prototype.$get = ['$q', '$http', '$timeout', function ($q, $http, $timeout) {
  return new FeatureToggleService(this.endpoint, $q, $http, $timeout);
}];

FeatureToggleServiceProvider.$inject = [];
